export default function GlobalPresence() {
  return (
    <section id="global" style={{ scrollMarginTop: '80px' }} className="pt-20 pb-20 px-6 min-h-screen relative overflow-hidden bg-sunset-warm/30">
      <div className="max-w-6xl mx-auto relative">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-ocean-mid/10 to-sunset-coral/10 px-4 py-1.5 rounded-full mb-4 border border-ocean-mid/20">
            <i className="ri-map-pin-line text-sunset-coral text-base"></i>
            <span className="text-xs font-bold text-ocean-mid uppercase tracking-wider">Where We Are</span>
          </div>
          <h4>
            <a href="#global" className="text-2xl md:text-3xl font-bold text-ocean-mid font-serif leading-tight block mb-3">
              Global Presence
            </a>
          </h4>
          <p className="text-sm text-gray-700 max-w-3xl mx-auto leading-relaxed">
            BB offers remote services you can reach anywhere in the world. Whether we provide global support or are ready to be on-site at our clients&apos; offices in the Netherlands to show our motivation and professional approach.
          </p>
        </div>

        {/* Service Locations */}
        <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto mb-8">
          {/* Netherlands */}
          <div className="bg-white rounded-xl p-5 border border-ocean-mid/15 shadow-lg text-center">
            <div className="text-4xl mb-3 filter drop-shadow-lg">🇳🇱</div>
            <h4 className="text-base font-bold text-ocean-mid mb-2">Netherlands</h4>
            <div className="flex items-center justify-center gap-2 flex-wrap">
              <div className="inline-flex items-center space-x-1 bg-ocean-mid text-white px-2.5 py-1 rounded-full text-xs font-bold shadow-lg">
                <i className="ri-wifi-line"></i>
                <span>Remote</span>
              </div>
              <div className="inline-flex items-center space-x-1 bg-sunset-coral text-white px-2.5 py-1 rounded-full text-xs font-bold shadow-lg">
                <i className="ri-building-2-line"></i>
                <span>On-site</span>
              </div>
            </div>
          </div>

          {/* Worldwide Remote */}
          <div className="bg-white rounded-xl p-5 border border-ocean-mid/15 shadow-lg text-center">
            <div className="w-12 h-12 bg-ocean-mid rounded-xl flex items-center justify-center mx-auto mb-3 shadow-lg">
              <i className="ri-earth-line text-white text-2xl"></i>
            </div>
            <h4 className="text-base font-bold text-ocean-mid mb-2">Worldwide</h4>
            <div className="inline-flex items-center space-x-2 bg-ocean-mid text-white px-3 py-1.5 rounded-full text-xs font-bold shadow-lg">
              <i className="ri-wifi-line"></i>
              <span>Remote Service</span>
            </div>
          </div>

          {/* Turkey */}
          <div className="bg-white rounded-xl p-5 border border-ocean-mid/15 shadow-lg text-center">
            <div className="text-4xl mb-3 filter drop-shadow-lg">🇹🇷</div>
            <h4 className="text-base font-bold text-ocean-mid mb-2">Türkiye</h4>
            <div className="flex items-center justify-center gap-2 flex-wrap">
              <div className="inline-flex items-center space-x-1 bg-ocean-mid text-white px-2.5 py-1 rounded-full text-xs font-bold shadow-lg">
                <i className="ri-wifi-line"></i>
                <span>Remote</span>
              </div>
              <div className="inline-flex items-center space-x-1 bg-sunset-coral text-white px-2.5 py-1 rounded-full text-xs font-bold shadow-lg">
                <i className="ri-building-2-line"></i>
                <span>On-site</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="text-center">
          <div className="inline-block relative">
            <div className="absolute inset-0 bg-ocean-mid rounded-2xl blur-xl opacity-30"></div>
            <div className="relative bg-ocean-mid text-white rounded-2xl px-8 py-6 shadow-2xl">
              <div className="flex flex-col md:flex-row items-center justify-center md:space-x-4 space-y-2 md:space-y-0">
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-earth-line text-3xl"></i>
                </div>
                <div className="text-center md:text-left">
                  <div className="text-lg md:text-xl font-bold font-serif mb-1">BB Always by your side, ready to support, guide, and ease the load</div>
                  <div className="text-sm md:text-base font-semibold">We&apos;re by your side for reliable, fast, and accurate support</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
